module.exports = __webpack_public_path__ + "img/shu.b0053613.jpg";